export default '/build/d042a2e6.svg'